import { render, staticRenderFns } from "./choise-rave-card.vue?vue&type=template&id=6e688fac&"
import script from "./choise-rave-card.vue?vue&type=script&lang=js&"
export * from "./choise-rave-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports